import { useCallback, useState } from "react";

const noop = () => {};

export default function useConfirmDialog({ onError = noop, t = {} } = {}) {
  const [confirmDialog, setConfirmDialog] = useState(null);

  const requestConfirm = useCallback((config) => {
    setConfirmDialog(config);
  }, []);

  const closeConfirm = useCallback(() => {
    setConfirmDialog(null);
  }, []);

  const runConfirmedAction = useCallback(async () => {
    const action = confirmDialog?.onConfirm;
    closeConfirm();

    try {
      await action?.();
    } catch (error) {
      onError(error.message || t.actionFailed || "Action failed.");
    }
  }, [closeConfirm, confirmDialog, onError, t.actionFailed]);

  return {
    closeConfirm,
    confirmDialog,
    requestConfirm,
    runConfirmedAction
  };
}
